import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { StyledDataGrid } from "./StyledDataGrid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ServiceTaxReport from "./Document/ServiceTaxReport";
import { pdf } from "@react-pdf/renderer";


const ServiceTaxReportonfees = () => {

    const [course, SetCourse] = useState([])
    const [brand, setBrand] = useState([])
    const [vendordata, setVendorData] = useState([])
    const [uid, setUid] = useState([])
    const [cid, setCid] = useState("")
    const [error, setError] = useState({})
    const [confirmationVisibleMap, setConfirmationVisibleMap] = useState({});
    const [checked, setChecked] = React.useState([true, false]);
    const [value, setValue] = useState({
        fromdate: '',
        todate: '',
    })
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });

    //==============Validation

    const validateForm = () => {
        let isValid = true
        const newErrors = {}

        if (!value.fromdate) {
            isValid = false;
            newErrors.fromdate = " From Date is Required"

        }

        if (!value.todate) {
            isValid = false;
            newErrors.todate = " To Date is Required"
        }

        setError(newErrors)
        return isValid
    }


    function formatDate(date) {
        // Convert to Date object if it's not already
        const d = new Date(date);

        const day = d.getDate(); // no leading zero (1 → 1, not 01)
        const month = d.getMonth() + 1; // months are 0-based
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    }



    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            const data = {

                fromdate: value.fromdate,
                todate: value.todate,

            };

            axios.post(`${BASE_URL}/getservicetaxreport`, data)
                .then((res) => {
                    console.log(res.data);
                    setVendorData(res.data);

                    // Calculate total amount
                    const totalAmount = res.data.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0);

                    // Set to receivedamount field
                    setValue((prev) => ({ ...prev, receivedamount: totalAmount.toFixed(2) }));
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const servicetaxreport = async () => {
        const res = await axios.post(`${BASE_URL}/getidStudent`, { batch_code: value.batch });
        const blob = await pdf(<ServiceTaxReport data={res.data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const columns = [
        {
            field: 'index',
            headerName: 'Id',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,

        },
        { field: 'Fees_Code', headerName: 'Receipt No.', flex: 2 },
        { field: 'Student_Name', headerName: 'Student Name', flex: 2 },
        {
            field: 'RDate',
            headerName: 'Receipt Date',
            flex: 2,
            renderCell: (params) => formatDate(params.value)
        },
        { field: 'Payment_Type', headerName: 'Payment Type', flex: 2 },
        { field: 'Amount', headerName: 'Amount', flex: 2 },
        { field: 'Cheque_No', headerName: 'Cheque No', flex: 2 },
        {
            field: 'Cheque_Date',
            headerName: 'Cheque Date',
            flex: 2,
            renderCell: (params) => formatDate(params.value)
        },


    ];


    const exportToExcel = () => {
        const worksheetData = [
            // Header Row (merged)
            [{
                v: `Service Tax Report: ${formatDate(value.fromdate)} To ${formatDate(value.todate)}`,
                s: { font: { bold: true, sz: 14 }, alignment: { horizontal: "center" } }
            }],


            [], // Empty row
            // Table Headers
            [
                { v: 'Receipt No.', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Student Name', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Receipt Date', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Payment Type', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Ammount', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Cheque No.', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
                { v: 'Cheque Date', s: { font: { bold: true }, fill: { fgColor: { rgb: "D9D9D9" } } } },
            ],
        ];

        // Adding Data Rows
        vendordata.forEach(item => {
            worksheetData.push([
                item.Fees_Code,
                item.Student_Name,
                formatDate(item.RDate),        // <-- Format Receipt Date
                item.Payment_Type,
                parseFloat(item.Amount).toFixed(2),
                item.Cheque_No,
                formatDate(item.Cheque_Date),  // <-- Format Cheque Date
            ]);
        });

        // Create worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merge the first header row across A1:G1
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];

        // Column widths
        worksheet['!cols'] = [
            { wch: 15 },
            { wch: 25 },
            { wch: 18 },
            { wch: 18 },
            { wch: 15 },
            { wch: 25 },
            { wch: 18 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // Export to file
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ServiceTaxReport.xlsx');
    };


    const rowsWithIds = vendordata.map((row, index) => ({ index: index + 1, ...row }));


    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">

                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin">
                            <div class="d-flex">

                                <div className='px-2 mx-2'><Link to="/servicetaxreportonfees"><h4>Month & Year Wise</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/chequenumber"><h4>Cheque Number</h4></Link></div>
                            </div>
                            <div className="card">
                                <div className='container-fluid'>
                                    <div className='row d-flex justify-content-between'>

                                        <div className='col-lg-12'>
                                            <div className='row justify-content-center' >
                                                <div className='p-3' style={{ width: "100%" }}>
                                                    <form class="form-sample py-3" onSubmit={handleSubmit}>
                                                        <div class="row">

                                                            <div className="form-group col-lg-3" style={{ display: "flex", flexDirection: "column" }}>
                                                                <lable for="exampleInputUsername1">From Date<span className="text-danger">*</span></lable>
                                                                <DatePicker
                                                                    selected={value.fromdate ? new Date(value.fromdate) : null}
                                                                    onChange={(date) =>
                                                                        onhandleChange({ target: { name: "fromdate", value: date } })
                                                                    }
                                                                    className="form-control"
                                                                    id="exampleInputUsername1"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Select From Date"
                                                                />
                                                                {<span className='text-danger'> {error.fromdate} </span>}
                                                            </div>

                                                            <div class="form-group col-lg-3" style={{ display: "flex", flexDirection: 'column' }}>
                                                                <lable for="exampleInputUsername1">To Date<span className="text-danger">*</span></lable>
                                                                <DatePicker
                                                                    selected={value.todate ? new Date(value.todate) : null}
                                                                    onChange={(date) =>
                                                                        onhandleChange({ target: { name: "todate", value: date } })
                                                                    }
                                                                    className="form-control"
                                                                    id="exampleInputUsername1"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Select To Date"
                                                                />

                                                                {<span className='text-danger'> {error.todate} </span>}
                                                            </div>

                                                        </div>

                                                        <div className='row p-2 gap-2'>
                                                            <button className='mr-2 btn btn-primary' onClick={handleSubmit}>Go</button>
                                                            <button type='button' className='mr-2 btn btn-primary' onClick={servicetaxreport}>Tax Report</button>
                                                        </div>


                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div className='d-flex justify-content-between' style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                                        <div>
                                                            <h4 class="card-title">Details</h4>
                                                        </div>

                                                    </div>

                                                    {<div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>

                                                        <StyledDataGrid
                                                            rows={rowsWithIds}
                                                            columns={columns}
                                                            // disableColumnFilter
                                                            disableColumnSelector
                                                            disableDensitySelector
                                                            rowHeight={35}
                                                            getRowId={(row) => row.index}
                                                            pagination
                                                            paginationModel={paginationModel}
                                                            onPaginationModelChange={setPaginationModel}
                                                            pageSizeOptions={[50]}
                                                            autoHeight={false}
                                                            sx={{
                                                                height: 500, // Ensure enough height for pagination controls
                                                                '& .MuiDataGrid-footerContainer': {
                                                                    justifyContent: 'flex-end',
                                                                },
                                                            }}
                                                            slots={{
                                                                toolbar: GridToolbar
                                                            }}
                                                            slotProps={{
                                                                toolbar: {
                                                                    showQuickFilter: true,
                                                                },
                                                            }}
                                                        />

                                                    </div>}

                                                    <div class="card-title text-center">
                                                        <h4>Total Record:</h4>
                                                        <div class="d-flex justify-content-center">

                                                            <div class="form-group">
                                                                <label for="exampleInputUsername1">Total Received Amount  </label>
                                                                <input
                                                                    style={{ width: "300px" }}
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="exampleInputUsername1"
                                                                    value={value.receivedamount}
                                                                    placeholder="Total Received Amount"
                                                                    name='receivedamount'
                                                                    onChange={onhandleChange}
                                                                    disabled
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="justify-content-center">
                                                        <button type="submit" class="btn btn-primary mr-2" onClick={exportToExcel}>Print</button>

                                                        <button type='button' onClick={() => {
                                                            window.location.reload()
                                                        }} class="btn btn-light">Close</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ServiceTaxReportonfees